import Route from '@ember/routing/route';

// Ensure the application route exists for ember-simple-auth's `setup-session-restoration` initializer
export default Route.extend();
